import { JOB_TYPES_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(JOB_TYPES_ENDPOINT);
export default instance;
